import React from 'react'

const UpdatePracticalTraining = () => {
  return (
    <div>UpdatePracticalTraining</div>
  )
}

export default UpdatePracticalTraining